@if (addressTemplate) {
  <ng-container [ngTemplateOutlet]="addressTemplate" [ngTemplateOutletContext]="context"></ng-container>
}
